export const MIN_FIELD_GROUP_NAME_LENGTH = 2;
